var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _g3, _path19, _path20, _path21, _path22, _path23, _g4, _path24, _g5, _path25, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg3MetuaaGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 51,
    viewBox: "0 0 72 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3282_1573)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.9394 45.6948H61.0792V48.562H71.9394V45.6948Z",
    fill: "url(#paint0_linear_3282_1573)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4156 45.6948H7.08981V48.562H61.4156V45.6948Z",
    fill: "#1D0C17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.0959473 48.5571H7.97997V45.6899H-0.0959473V48.5571Z",
    fill: "url(#paint1_linear_3282_1573)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.0625,
    y: 42.6875,
    width: 17.1875,
    height: 25.125,
    transform: "rotate(-180 17.0625 42.6875)",
    fill: "url(#paint2_linear_3282_1573)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.875 24.3301H54.5023C54.5023 24.3301 56.0497 25.5016 56.1562 25.8757C56.2627 26.2498 56.1058 27.6084 56.1058 27.6084L51.6263 27.0915L50.8806 24.3301H50.875Z",
    fill: "#A1989B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4397 32.3437H2.84698V46.3674H26.4397V32.3437Z",
    fill: "url(#paint3_linear_3282_1573)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7729 30.5223H22.3886C20.085 30.5223 18.2194 34.1107 18.2194 38.5359C18.2194 42.9611 20.085 46.5495 22.3886 46.5495H28.7729C31.0766 46.5495 32.9421 42.9611 32.9421 38.5359C32.9421 34.1107 31.0766 30.5223 28.7729 30.5223Z",
    fill: "#1D0C17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.003 30.2812H30.5252C28.1871 30.2812 26.292 33.9238 26.292 38.4179C26.292 42.912 28.1871 46.5545 30.5252 46.5545H37.003C39.3411 46.5545 41.2362 42.912 41.2362 38.4179C41.2362 33.9238 39.3411 30.2812 37.003 30.2812Z",
    fill: "#1D0C17"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5784 30.2812H6.49928C4.30392 30.2812 2.52695 33.9238 2.52695 38.4179C2.52695 42.912 4.30392 46.5545 6.49928 46.5545H12.5784C14.7737 46.5545 16.5507 42.912 16.5507 38.4179C16.5507 33.9238 14.7737 30.2812 12.5784 30.2812Z",
    fill: "#1D0C17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0932 30.5223H60.7089C58.4053 30.5223 56.5397 34.1107 56.5397 38.5359C56.5397 42.9611 58.4053 46.5495 60.7089 46.5495H67.0932C69.3969 46.5495 71.2624 42.9611 71.2624 38.5359C71.2624 34.1107 69.3969 30.5223 67.0932 30.5223Z",
    fill: "#1D0C17"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7731 39.732C2.7288 39.7764 2.02983 29.5477 1.99537 28.6617C1.96091 27.7757 14.5769 27.8791 14.5769 27.8791L11.7416 38.1815C11.7416 38.1815 9.76282 37.6548 9.62991 37.6548C9.49701 37.6548 7.20812 34.0025 7.20812 34.0025L5.66743 33.2986L4.30395 34.1797C4.30395 34.1797 6.46977 40.0372 4.3827 39.8945C2.29563 39.7517 2.7731 39.7419 2.7731 39.7419V39.732Z",
    fill: "#1D0C17"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9648 44.1671H11.1706V40.4261H27.7736L28.9648 44.1671Z",
    fill: "#1D0C17"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6543 32.8557V29.9958L29.9345 29.2033L25.4454 30.5668V41.834L27.7343 41.3516L27.9065 38.6197L28.3939 35.627L29.8016 33.5596L35.6543 32.8557Z",
    fill: "#1D0C17"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9123 32.6685C71.8877 32.3978 71.4545 31.7923 70.9229 31.2214C70.5242 30.7882 69.6431 30.0548 68.9392 29.6659C68.2353 29.277 64.8881 27.697 60.3842 27.0521C55.8802 26.4122 45.2283 24.7829 45.2283 24.7829L43.1117 20.1707C43.1117 20.1707 43.4858 19.9295 43.0674 19.4324C42.6441 18.9352 39.5479 17.5176 32.2727 17.5176H17.5992C15.9502 17.5176 14.6261 17.5274 11.1411 19.9443C7.6561 22.3612 7.33122 25.1915 5.15555 26.3335C3.06848 27.4262 1.98557 27.8643 1.98557 27.8643L2.56148 32.0582C2.56148 32.0582 2.98972 31.5265 3.98403 29.0014C4.98327 26.4713 31.7165 28.0908 33.0553 29.1983C33.2916 29.3952 33.7986 30.9309 33.9561 31.182C34.9898 32.8703 36.4075 34.7458 36.8652 37.8468C37.323 40.9528 37.6479 42.715 37.6479 42.715L70.5734 42.8676C71.2527 41.7305 71.7344 38.2031 71.8434 37.3743C71.9523 36.5454 71.9713 33.3134 71.9172 32.6685H71.9123Z",
    fill: "#E7E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3282_1573",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 17,
    width: 71,
    height: 26
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9123 32.6685C71.8877 32.3978 71.4545 31.7923 70.9229 31.2214C70.5242 30.7882 69.6431 30.0548 68.9392 29.6659C68.2353 29.277 64.8881 27.697 60.3842 27.0521C55.8802 26.4122 45.2283 24.7829 45.2283 24.7829L43.1117 20.1707C43.1117 20.1707 43.4858 19.9295 43.0674 19.4324C42.6441 18.9352 39.5479 17.5176 32.2727 17.5176H17.5992C15.9502 17.5176 14.6261 17.5274 11.1411 19.9443C7.6561 22.3612 7.33122 25.1915 5.15555 26.3335C3.06848 27.4262 1.98557 27.8643 1.98557 27.8643L2.56148 32.0582C2.56148 32.0582 2.98972 31.5265 3.98403 29.0014C4.98327 26.4713 31.7165 28.0908 33.0553 29.1983C33.2916 29.3952 33.7986 30.9309 33.9561 31.182C34.9898 32.8703 36.4075 34.7458 36.8652 37.8468C37.323 40.9528 37.6479 42.715 37.6479 42.715L70.5734 42.8676C71.2527 41.7305 71.7344 38.2031 71.8434 37.3743C71.9523 36.5454 71.9713 33.3134 71.9172 32.6685H71.9123Z",
    fill: "#E7E5E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3282_1573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4563 24.604L18.2283 -0.33667L4.86377 31.6358L59.0918 56.5765L72.4563 24.604Z",
    fill: "url(#paint4_linear_3282_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M73.6417 38.3335H32.2766V41.1756H73.6417V38.3335Z",
    fill: "url(#paint5_linear_3282_1573)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.666 33.6038C37.0031 29.5921 31.4457 27.8447 30.1118 27.4214C28.7828 26.998 27.311 26.3483 25.9475 24.8913C24.5791 23.4343 21.1335 19.9837 19.7995 18.8713C18.4655 17.7588 16.7329 17.4536 14.8279 17.9459C12.9279 18.4381 12.8885 18.6891 11.1706 19.8803C8.06465 22.0314 4.47627 24.6452 1.73945 25.2752C1.78375 29.09 2.30059 33.8007 2.30059 33.8007C2.9405 30.6996 4.53041 29.1048 6.37629 29.4887C8.22216 29.8727 10.0582 31.945 10.8113 35.4841C11.6038 39.2153 10.644 41.8733 10.644 41.8733H25.8294C25.3863 39.801 24.8744 36.5671 25.662 33.5103C26.4447 30.4535 29.2701 28.4501 32.1595 29.9465C35.3836 31.6201 36.0038 37.1873 35.0538 42.715H39.2427C39.7793 40.6526 41.064 35.7106 39.666 33.6038Z",
    fill: "#B9B2B4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3282_1573",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 17,
    width: 40,
    height: 26
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.666 33.6038C37.0031 29.5921 31.4457 27.8447 30.1118 27.4214C28.7828 26.998 27.311 26.3483 25.9475 24.8913C24.5791 23.4343 21.1335 19.9837 19.7995 18.8713C18.4655 17.7588 16.7329 17.4536 14.8279 17.9459C12.9279 18.4381 12.8885 18.6891 11.1706 19.8803C8.06465 22.0314 4.47627 24.6452 1.73945 25.2752C1.78375 29.09 2.30059 33.8007 2.30059 33.8007C2.9405 30.6996 4.53041 29.1048 6.37629 29.4887C8.22216 29.8727 10.0582 31.945 10.8113 35.4841C11.6038 39.2153 10.644 41.8733 10.644 41.8733H25.8294C25.3863 39.801 24.8744 36.5671 25.662 33.5103C26.4447 30.4535 29.2701 28.4501 32.1595 29.9465C35.3836 31.6201 36.0038 37.1873 35.0538 42.715H39.2427C39.7793 40.6526 41.064 35.7106 39.666 33.6038Z",
    fill: "#B9B2B4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3282_1573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3944 28.095H1.5956V41.9762H44.3944V28.095Z",
    fill: "url(#paint6_linear_3282_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9223 53.4093L5.58058 21.5786L25.9972 6.3042L49.6814 38.1348L27.9223 53.4093Z",
    fill: "url(#paint7_linear_3282_1573)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8301 30.2762C67.8858 30.5027 68.0531 32.6488 68.0531 32.6488L71.9024 32.6242C71.9024 32.6242 71.8867 31.6798 69.8555 30.2775L69.8301 30.2762Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7495 18.502C20.7495 18.502 28.9205 18.2412 34.847 18.3691C40.7686 18.502 42.6095 19.0927 42.6095 19.0927L54.113 26.1218H30.0773C29.2995 26.1218 28.8516 25.8363 27.8721 24.9257C26.9221 24.0397 22.1326 19.6686 20.7495 18.502Z",
    fill: "#16A34A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9334 25.861C24.4166 24.7289 21.0153 20.5695 19.2826 19.4866C17.7124 18.5021 16.3144 18.4184 13.996 19.2946C12.4356 19.8853 10.0778 22.7156 6.86356 24.2465C8.34026 26.2942 12.1649 26.7913 14.9953 26.7913C18.3424 26.7913 20.7052 26.8996 22.1474 26.8996C24.2148 26.8996 25.2977 26.6535 24.9384 25.861H24.9334Z",
    fill: "#16A34A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3282_1573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 18,
    width: 49,
    height: 9
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7495 18.502C20.7495 18.502 28.9205 18.2411 34.847 18.3691C40.7686 18.502 42.6096 19.0927 42.6096 19.0927L54.1131 26.1217H30.0773C29.2996 26.1217 28.8516 25.8363 27.8721 24.9256C26.9221 24.0396 22.1326 19.6686 20.7495 18.502ZM24.9334 25.8609C24.4166 24.7287 21.0153 20.5694 19.2826 19.4864C17.7124 18.502 16.3144 18.4183 13.996 19.2945C12.4356 19.8851 10.9343 21.9771 6.86356 24.2463C8.34026 26.294 12.1649 26.7912 14.9953 26.7912C18.3424 26.7912 20.7052 26.8995 22.1474 26.8995C24.2148 26.8995 25.2977 26.6534 24.9384 25.8609H24.9334Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3282_1573)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.3125,
    y: 27.8749,
    width: 10.1875,
    height: 52.4375,
    transform: "rotate(-90 4.3125 27.8749)",
    fill: "url(#paint8_linear_3282_1573)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5848 26.8504H22.3493C21.8078 26.8504 20.5132 24.2219 20.5132 24.2219H17.5746C17.5746 24.2219 16.7526 25.167 16.7526 26.117C16.7526 27.067 18.1653 28.2828 18.1653 28.2828H22.7037C23.5159 28.2828 23.5799 26.8504 23.5799 26.8504H23.5848Z",
    fill: "#CFCBCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6677 44.1671H34.4582V41.8536H70.9721C70.9721 41.8536 70.4995 43.6256 69.6677 44.1671Z",
    fill: "#1D0C17"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3555 29.2754C44.1573 29.2896 46.0627 29.4222 48.0342 29.749C51.1795 30.2708 52.5823 31.3937 52.666 32.7178C49.8906 32.8483 47.0582 32.8509 44.874 32.7783C44.715 32.4975 44.4853 32.1074 44.1924 31.6592C43.7284 30.9492 43.1032 30.0872 42.3555 29.2754ZM41.5645 29.2764C42.4468 30.1592 43.1847 31.1595 43.7148 31.9707C43.904 32.2601 44.0643 32.5255 44.1973 32.75C43.2253 32.708 42.4178 32.6532 41.8516 32.585C41.2265 32.5062 40.5225 32.0041 39.9072 31.4922C38.8053 30.5764 37.9326 29.475 37.9238 29.4639V29.459C39.0718 29.3603 40.2899 29.2903 41.5645 29.2764Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78368 26.4713C1.90181 26.5107 3.221 26.4221 4.35313 26.2252C5.3376 26.0529 3.69846 27.3967 3.14224 27.8742C2.61555 28.3172 1.89197 29.0161 1.89197 29.0161L1.7886 26.4713H1.78368Z",
    fill: "#746A6E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3282_1573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 32,
    width: 7,
    height: 13
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0312 38.6094C27.0312 35.0937 28.3903 32.25 30.0625 32.25C31.7347 32.25 33.0937 35.0997 33.0937 38.6094C33.0937 42.119 31.7347 44.9688 30.0625 44.9688C28.3903 44.9688 27.0312 42.119 27.0312 38.6094Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3282_1573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0937 38.6094C33.0937 42.125 31.7347 44.9688 30.0625 44.9688C28.3903 44.9688 27.0312 42.119 27.0312 38.6094C27.0312 35.0997 28.3903 32.25 30.0625 32.25C31.7347 32.25 33.0937 35.0997 33.0937 38.6094Z",
    fill: "#746A6E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M28.5768 49.0303L39.1249 43.7412L31.6981 30.1501L21.1501 35.4393L28.5768 49.0303Z",
    fill: "url(#paint9_linear_3282_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M31.7097 38.7893C31.7097 41.441 30.8141 43.5888 29.7056 43.5888C28.5971 43.5888 27.7015 41.441 27.7015 38.7893C27.7015 36.1375 28.5971 33.9897 29.7056 33.9897C30.8141 33.9897 31.7097 36.1375 31.7097 38.7893Z",
    fill: "#746A6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3282_1573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 32,
    width: 6,
    height: 13
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 38.6094C3.25 35.0937 4.52498 32.25 6.09375 32.25C7.66251 32.25 8.9375 35.0997 8.9375 38.6094C8.9375 42.119 7.66251 44.9688 6.09375 44.9688C4.52498 44.9688 3.25 42.119 3.25 38.6094Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3282_1573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 38.6094C8.9375 42.125 7.66251 44.9688 6.09375 44.9688C4.52498 44.9688 3.25 42.119 3.25 38.6094C3.25 35.0997 4.52498 32.25 6.09375 32.25C7.66251 32.25 8.9375 35.0997 8.9375 38.6094Z",
    fill: "#746A6E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M4.69998 49.0303L14.5956 43.7412L7.62821 30.1501L-2.26741 35.4393L4.69998 49.0303Z",
    fill: "url(#paint10_linear_3282_1573)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M7.63908 38.7893C7.63908 41.441 6.79888 43.5888 5.75892 43.5888C4.71895 43.5888 3.87875 41.441 3.87875 38.7893C3.87875 36.1375 4.71895 33.9897 5.75892 33.9897C6.79888 33.9897 7.63908 36.1375 7.63908 38.7893Z",
    fill: "#746A6E"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4783 8.72029L64.211 8.58196L64.4398 0L56.1292 12.2797L61.3964 12.418L61.1677 21L69.4783 8.72029Z",
    fill: "#16A34A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3282_1573",
    x1: 61.0841,
    y1: 47.1259,
    x2: 71.9394,
    y2: 47.1259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1D0C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D0C17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3282_1573",
    x1: 7.97997,
    y1: 47.126,
    x2: -0.0959473,
    y2: 47.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1D0C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D0C17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3282_1573",
    x1: 17.0625,
    y1: 55.25,
    x2: 34.25,
    y2: 55.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#B9B2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.990385,
    stopColor: "#B9B2B4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3282_1573",
    x1: 18.879,
    y1: 39.358,
    x2: 1.81329,
    y2: 39.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1D0C17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3282_1573",
    x1: 10.9938,
    y1: 15.3988,
    x2: 66.3263,
    y2: 40.8461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3282_1573",
    x1: 52.9566,
    y1: 39.2454,
    x2: 52.9566,
    y2: 41.3023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#746A6E",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3282_1573",
    x1: 22.995,
    y1: 32.5481,
    x2: 22.995,
    y2: 42.5892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#746A6E",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3282_1573",
    x1: 32.875,
    y1: 21,
    x2: 15.125,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#746A6E",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3282_1573",
    x1: 4.3125,
    y1: 54.0937,
    x2: 14.5,
    y2: 54.0937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115385,
    stopColor: "#42003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913462,
    stopColor: "#42003B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3282_1573",
    x1: 25.9215,
    y1: 40.836,
    x2: 36.2785,
    y2: 35.1765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CFCBCC",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3282_1573",
    x1: 2.20888,
    y1: 40.836,
    x2: 12.2007,
    y2: 35.7138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CFCBCC",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3282_1573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3MetuaaGreen);
export default __webpack_public_path__ + "static/media/img3_metuaa_green.30a381a9cc5f2fea838139681da5f2c8.svg";
export { ForwardRef as ReactComponent };